import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private http: HttpClient, private router: Router, private authService: AuthService) { }

  sendMessage(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/provider-email-support/send-message', data, httpOptions);
  }

  getDoctorType() {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/doctors/getDoctorType', httpOptions);
  }

  getDoctorSpeciality() {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerBranch/getAllDoctorSpecialtyType', httpOptions);
  }

  addDoctor(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/doctors/add-doctor', data, httpOptions);
  }

  getDoctors() {
    const param = new HttpParams().set('providerBranchProfileId', this.authService.currentUserValue.providerBranchProfile.id);
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/doctors/get-doctor', httpOptions);
  }

  editDoctor(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/doctors/edit-doctor', data, httpOptions);
  }

  deleteDoctor(id: any) {
    const param = new HttpParams()
      .set('doctorId', id)
      .set('proBranchProfId', this.authService.currentUserValue.providerBranchProfile.id)
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: param
    };
    return this.http.delete(environment.apiBaseUrl + '/trueclaim/doctors/delete-doctor', httpOptions);
  }

  fetchUpdatesAndAnnouncements() {
    return this.http.get(environment.apiBaseUrl + '/trueclaim/updatesAndAnnouncements/fetch-updates-and-announcements');
  }

  fetchDoctorDetails(queryNumber: any, type: any) {
    const params = new HttpParams()
      .set('key', type)
      .set('number', queryNumber)
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: params
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/providerBranch/get-Singledoctor', httpOptions);
  }

  fetchMailbox(pageIndex: any, pageSize: any) {
    const params = new HttpParams()
      .set('page', pageIndex)
      .set('pageSize', pageSize)
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: params
    };
    return this.http.get(environment.apiBaseUrl + '/trueclaim/mailRead/fetch-mail', httpOptions);
  }

  attachMailToClaim(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/mailRead/copy-attachment-to-claim', data, httpOptions);
  }

  configureMailbox(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/mailRead/configure-mailbox', data, httpOptions);
  }

  downloadAttachment(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };
    return this.http.post(environment.apiBaseUrl + '/trueclaim/mailRead/download-attachment', data, httpOptions);
  }
}
